import { ArrayBase } from '../ArrayBase';

export class LiveEvents extends ArrayBase {}
